/*global themeVars */

/**
 * Header Class
 */
export class MegaMenu {

	navMobileBackLink;

	searchTrigger;

	pageBody;

	/**
	 * Constructor
	 *
	 * @return {void}
	 */
	constructor() {

		this.navMobileBackLink = document.querySelector( '.header-menu__back' );
		this.searchTrigger = document.querySelector( '.js-search-trigger' );
		this.pageBody = document.querySelector( 'body' );

		this.navTrigger();
		this.mobileMenuBackLink();
		this.handleSearchTrigger();
		this.displaySearchPrompts();
		this.hideSearchPrompts();

	}

	/**
	 * Check if screen size is less than 1140px
	 *
	 * @return {boolean}
	 */
	isMobile() {

		return window.matchMedia( '(max-width: 1140px)' ).matches

	}

	/**
	 * Navigation trigger
	 * Open/close megamenu or search component
	 *
	 */
	navTrigger() {

		const navTrigger = document.querySelector( '.js-nav-trigger' );

		if ( navTrigger ) {

			navTrigger.addEventListener( 'click', () => {

				const megamenuLogoTemplate = document.querySelector( '.header-logo-megamenu-opened-template' );

				this.pageBody.classList.toggle( 'js-nav-open' );
				this.pageBody.classList.toggle( 'body-no-scroll' );
				this.pageBody.classList.remove( 'js-search-open' );

				// show other logo image
				if ( navTrigger.classList.contains( 'header-menu-trigger' ) && megamenuLogoTemplate ) {

					const megamenuLogo = megamenuLogoTemplate.content.cloneNode( true );

					megamenuLogoTemplate.replaceWith( megamenuLogo );

				}

			} );

		}

	}

	/**
	 * Mobile menu back link
	 *
	 */
	mobileMenuBackLink() {

		if ( this.navMobileBackLink ) {

			this.navMobileBackLink.addEventListener( 'click', () => {

				this.pageBody.classList.remove( 'js-nav-back' );

				const clonedItem = document.querySelector( '.js-clone' );
				clonedItem.remove();

			} );

		}

	}

	/**
	 * Search trigger
	 *
	 */
	handleSearchTrigger() {

		if ( this.searchTrigger ) {

			this.searchTrigger.addEventListener( 'click', () => {

				const searchForms = document.querySelectorAll( '.search-form' );
				const searchPromptsContainers = document.querySelectorAll( '.search-form__prompts' );
				const searchWindow = document.querySelector( '.search-window' );
				const searchWindowContent = searchWindow.querySelector( '.search-window__content' );
				const megamenuLogoTemplate = document.querySelector( '.header-logo-megamenu-opened-template' );

				if ( searchForms.length > 0 ) {

					searchForms.forEach( ( searchForm ) => {

						searchForm.classList.remove( 'js-active' );

					} );

				}

				if ( searchPromptsContainers.length > 0 ) {

					searchPromptsContainers.forEach( ( searchPromptsContainer ) => {

						searchPromptsContainer.innerHTML = '';

					} );

				}

				this.pageBody.classList.toggle( 'js-search-open' );
				this.pageBody.classList.toggle( 'body-no-scroll' );
				this.pageBody.classList.remove( 'js-nav-open' );

				if ( searchWindowContent ) {

					if ( this.pageBody.classList.contains( 'js-search-open' ) ) {

						const searchWindowHeight = ( window.innerHeight - Math.ceil( searchWindowContent.getBoundingClientRect().top ) - 20 );
						searchWindowContent.style.maxHeight = `${ searchWindowHeight }px`;

					} else {

						searchWindowContent.style.maxHeight = '';

					}

				}

				// show other logo image
				if ( megamenuLogoTemplate ) {

					const megamenuLogo = megamenuLogoTemplate.content.cloneNode( true );

					megamenuLogoTemplate.replaceWith( megamenuLogo );

				}

			} );

		}

	}

	/**
	 * Display search prompts
	 */
	displaySearchPrompts() {

		let timer;
		const searchInputs = document.querySelectorAll( '.search-form__input' );

		if ( searchInputs.length > 0 ) {

			searchInputs.forEach( ( searchInput ) => {

				searchInput.addEventListener( 'input', ( e ) => {

					const searchForm = e.target.closest( '.search-form' );
					const key = e.target.value;
					const debounceGetSearchPrompt = this.debounce( () => this.getSearchPrompt( key, searchForm ), 250 );

					clearTimeout( timer );
					timer = setTimeout( () => {

						debounceGetSearchPrompt( key, searchForm );

					}, 500 );

				} );

			} );

		}

	}

	/**
	 * Hide Search prompts
	 */
	hideSearchPrompts() {

		this.pageBody.addEventListener( 'click', ( e ) => {

			const target = e.target;

			if ( ! target.classList.contains( 'search-form' ) && ! target.classList.contains( 'search-form__input' ) ) {

				const searchForms = document.querySelectorAll( '.search-form' );
				const searchPromptsContainers = document.querySelectorAll( '.search-form__prompts' );

				if ( searchForms.length > 0 ) {

					searchForms.forEach( ( searchForm ) => {

						searchForm.classList.remove( 'js-active' );

					} );

				}

				if ( searchPromptsContainers.length > 0 ) {

					searchPromptsContainers.forEach( ( searchPromptsContainer ) => {

						searchPromptsContainer.innerHTML = '';

					} );

				}

			}

		} );

	}

	/**
	 * Gets Search prompt
	 * Performs AJAX request
	 *
	 * @param {string} key
	 * @param {Element} searchForm
	 */
	getSearchPrompt( key, searchForm ) {

		const searchPromptsContainer = searchForm.querySelector( '.search-form__prompts' );

		if ( searchPromptsContainer ) {

			searchPromptsContainer.innerHTML = '';

		}

		if ( key.length > 0 ) {

			searchForm.classList.add( 'js-active' );

			const body = new FormData();
			body.append( 'action', 'get_search_prompts' );
			body.append( 'nonce', themeVars.security );
			body.append( 'key', key );

			fetch( themeVars.ajax_url, {
				method: 'POST',
				credentials: 'same-origin',
				body: body,
			} )
				.then( ( response ) => response.json() )
				.then( ( data ) => {

					if ( Array.isArray( data.data ) && data.data.length > 0 ) {

						let li, a;

						data.data.forEach( ( prompt ) => {

							if ( typeof prompt === 'string' ) {

								prompt = JSON.parse( prompt );

							}

							a = document.createElement( 'a' );
							li = document.createElement( 'li' );
							a.setAttribute( 'href', prompt.link )
							a.textContent = prompt.title;
							li.appendChild( a );
							searchPromptsContainer.appendChild( li );

						} );

					}

				} )
				.catch( ( error ) => {

					// eslint-disable-next-line no-console
					console.error( 'Error:', error );

				} );

		} else {

			searchForm.classList.remove( 'js-active' );

		}

	};

	/**
	 * Debounce
	 *
	 * @param {function} callback
	 * @param {integer} delay
	 * @return {(function(...[*]): void)|*}
	 */
	debounce( callback, delay ) {

		let timeoutId;
		/* eslint-disable func-names */
		return function( ...args ) {

			clearTimeout( timeoutId );
			timeoutId = setTimeout( () => {

				callback.apply( this, args );

			}, delay );

		};

	}

}